export const supportsTouchScreen: () => boolean = () => {
  return !!('ontouchstart' in window);
};

export const getSmallScreenMatchMedia = (): MediaQueryList =>
  window.matchMedia('(min-width: 768px)');

export const getLargeScreenMatchMedia = (): MediaQueryList =>
  window.matchMedia('(min-width: 1024px)');

export const getTabletScreenMatchMedia = (): MediaQueryList =>
  window.matchMedia('(max-width: 1023px)');

export const isSmallScreen: () => boolean = () => {
  const { matches } = window.matchMedia('(min-width: 768px)');
  return !matches;
};

export const isLargeScreen: () => boolean = () => {
  const { matches } = window.matchMedia('(min-width: 1024px)');
  return matches;
};

export const isTabletScreen: () => boolean = () => {
  const { matches } = window.matchMedia('(max-width: 1023px)');
  return matches;
};
